export function initSimulator() {
  var modal = document.getElementById('mjSimModal');
  if (!modal) return;

  var body = modal.querySelector('.mj-sim-modal__body');
  var steps = body.querySelectorAll('.mj-simulator__step');
  var liveBar = document.getElementById('simLiveBar');
  var livePriceEl = document.getElementById('simLivePrice');
  var livePriceTaxEl = document.getElementById('simLivePriceTax') || { textContent: '' };
  var liveServiceNameEl = document.getElementById('simLiveServiceName');
  var TAX_RATE = 0.10;
  var progressSteps = body.querySelectorAll('.mj-simulator__progress-step');
  var state = { service: null, group: null, base: 0, pageAdd: 0, multiply: 1, features: [], currentStep: '1' };

  var serviceNames = {
    lp: '\u30E9\u30F3\u30C7\u30A3\u30F3\u30B0\u30DA\u30FC\u30B8\u5236\u4F5C', corporate: '\u30B3\u30FC\u30DD\u30EC\u30FC\u30C8\u30B5\u30A4\u30C8\u5236\u4F5C',
    recruit: '\u63A1\u7528\u30B5\u30A4\u30C8\u5236\u4F5C',
    renewal: '\u30B5\u30A4\u30C8\u30EA\u30CB\u30E5\u30FC\u30A2\u30EB\u30FB\u6539\u5584', video: 'AI\u52D5\u753B\u5236\u4F5C',
    'lecture-ai': '\u751F\u6210AI\u30EC\u30AF\u30C1\u30E3\u30FC', 'lecture-web': 'Web\u5236\u4F5C\u30EC\u30AF\u30C1\u30E3\u30FC',
    'lecture-video': 'AI\u52D5\u753B\u5236\u4F5C\u30EC\u30AF\u30C1\u30E3\u30FC',
    'ai-consulting': 'AI\u5C0E\u5165\u30B3\u30F3\u30B5\u30EB\u30C6\u30A3\u30F3\u30B0'
  };

  var formatYen = function (n) { return '\u00A5' + n.toLocaleString('ja-JP'); };
  var getGroup = function (s) {
    if (s === 'video') return 'video';
    if (['lecture-ai', 'lecture-web', 'lecture-video', 'ai-consulting'].indexOf(s) !== -1) return 'lecture';
    return 'production';
  };

  var calcLiveTotal = function () {
    if (!state.service) return 0;
    if (state.group === 'lecture' || state.group === 'video') return Math.round(state.base * state.multiply);
    var t = state.base + state.pageAdd;
    state.features.forEach(function (f) { t += f.price; });
    return t;
  };

  var updateLiveBar = function () {
    if (!state.service) { liveBar.classList.remove('is-visible'); return; }
    liveBar.classList.add('is-visible');
    liveServiceNameEl.textContent = serviceNames[state.service] || '';
    var total = calcLiveTotal();
    livePriceEl.textContent = formatYen(total);
    var tax = Math.round(total * TAX_RATE);
    livePriceTaxEl.textContent = '\u7A0E\u8FBC ' + formatYen(total + tax) + '\uFF08\u7A0E ' + formatYen(tax) + '\uFF09';
  };

  var updateProgress = function (target) {
    var order = { '1': 0, '2': 1, '3': 2, 'result': 3 };
    var idx = order[target] !== undefined ? order[target] : 0;
    progressSteps.forEach(function (ps, i) {
      ps.classList.remove('is-active', 'is-done');
      if (i < idx) ps.classList.add('is-done');
      if (i === idx) ps.classList.add('is-active');
    });
  };

  var showStep = function (target) {
    state.currentStep = target;
    steps.forEach(function (s) { s.classList.remove('is-active'); });
    var sel;
    if (target === 'result') {
      sel = body.querySelector('[data-step="result"]');
    } else {
      body.querySelectorAll('[data-step="' + target + '"]').forEach(function (c) {
        if (!c.dataset.group || c.dataset.group === state.group) sel = c;
      });
    }
    if (sel) {
      sel.classList.add('is-active');
      modal.querySelector('.mj-sim-modal__body').scrollTop = 0;
    }
    updateProgress(target);
    updateLiveBar();
  };

  var collectFeatures = function () {
    state.features = [];
    body.querySelectorAll('[data-step="3"] input[type="checkbox"]:checked').forEach(function (cb) {
      state.features.push({ name: cb.dataset.feature, price: parseInt(cb.dataset.add, 10) });
    });
  };

  var lastResultRows = [];
  var lastResultTotal = 0;

  var buildResult = function () {
    var rows = [], total = 0;
    if (state.group === 'lecture' || state.group === 'video') {
      var amt = Math.round(state.base * state.multiply);
      rows.push({ name: serviceNames[state.service], price: amt });
      total = amt;
    } else {
      rows.push({ name: serviceNames[state.service] + '\uFF08\u57FA\u672C\uFF09', price: state.base });
      total += state.base;
      if (state.pageAdd > 0) { rows.push({ name: '\u30DA\u30FC\u30B8\u8FFD\u52A0', price: state.pageAdd }); total += state.pageAdd; }
      var fn = { wp: 'WordPress\u69CB\u7BC9', blog: '\u30D6\u30ED\u30B0\u6A5F\u80FD', form: '\u304A\u554F\u3044\u5408\u308F\u305B\u30D5\u30A9\u30FC\u30E0', seo: 'SEO\u8A2D\u8A08\u5F37\u5316', sns: 'SNS\u9023\u643A', analytics: '\u30A2\u30AF\u30BB\u30B9\u89E3\u6790\u8A2D\u5B9A' };
      state.features.forEach(function (f) { rows.push({ name: fn[f.name] || f.name, price: f.price }); total += f.price; });
    }
    lastResultRows = rows;
    lastResultTotal = total;

    var tbody = document.getElementById('simResultBody');
    tbody.innerHTML = '';
    rows.forEach(function (r) {
      var tr = document.createElement('tr');
      tr.innerHTML = '<td>' + r.name + '</td><td>' + formatYen(r.price) + '</td>';
      tbody.appendChild(tr);
    });
    var tax = Math.round(total * TAX_RATE);
    var taxIncluded = total + tax;

    var trSub = document.createElement('tr');
    trSub.className = 'mj-simulator__result-total-row';
    trSub.innerHTML = '<td>\u5C0F\u8A08</td><td>' + formatYen(total) + '</td>';
    tbody.appendChild(trSub);
    var trTaxRow = document.createElement('tr');
    trTaxRow.className = 'mj-simulator__result-total-row';
    trTaxRow.innerHTML = '<td>\u6D88\u8CBB\u7A0E</td><td>' + formatYen(tax) + '</td>';
    tbody.appendChild(trTaxRow);
    var trTotal = document.createElement('tr');
    trTotal.className = 'mj-simulator__result-tax-row';
    trTotal.innerHTML = '<td>\u5408\u8A08\u91D1\u984D</td><td>' + formatYen(taxIncluded) + '</td>';
    tbody.appendChild(trTotal);

    document.getElementById('simTotalValue').textContent = formatYen(taxIncluded);
    var exTaxEl = document.getElementById('simTotalExTax');
    if (exTaxEl) exTaxEl.textContent = '\u7A0E\u629C ' + formatYen(total) + '\uFF08\u6D88\u8CBB\u7A0E ' + formatYen(tax) + '\uFF09';

    var dateEl = document.getElementById('simEstimateDate');
    if (dateEl) {
      var d = new Date();
      dateEl.textContent = '\u767A\u884C\u65E5\uFF1A' + d.getFullYear() + '\u5E74' + (d.getMonth() + 1) + '\u6708' + d.getDate() + '\u65E5';
    }
  };

  var selectService = function (slug) {
    var btn = body.querySelector('[data-step="1"] [data-service="' + slug + '"]');
    if (!btn) return false;
    state.service = slug;
    state.base = parseInt(btn.dataset.base, 10);
    state.group = getGroup(slug);
    state.pageAdd = 0;
    state.multiply = 1;
    state.features = [];
    body.querySelectorAll('[data-step="1"] .mj-simulator__option').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    return true;
  };

  var resetSim = function () {
    state = { service: null, group: null, base: 0, pageAdd: 0, multiply: 1, features: [], currentStep: '1' };
    body.querySelectorAll('.mj-simulator__option').forEach(function (b) { b.classList.remove('is-selected'); });
    body.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
    showStep('1');
  };

  var openSimModal = function (serviceSlug) {
    resetSim();
    if (serviceSlug && selectService(serviceSlug)) {
      showStep('2');
    }
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  var closeSimModal = function () {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  document.querySelectorAll('[data-sim-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openSimModal(trigger.dataset.simService || '');
    });
  });

  modal.querySelectorAll('[data-sim-close]').forEach(function (el) {
    el.addEventListener('click', closeSimModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeSimModal();
  });

  body.querySelectorAll('[data-step="1"] .mj-simulator__option').forEach(function (btn) {
    btn.addEventListener('click', function () { selectService(btn.dataset.service); showStep('2'); });
  });

  body.querySelectorAll('[data-step="2"][data-group="production"] .mj-simulator__option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.pageAdd = parseInt(btn.dataset.add, 10);
      body.querySelectorAll('[data-step="2"][data-group="production"] .mj-simulator__option').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      updateLiveBar();
      showStep('3');
    });
  });

  body.querySelectorAll('[data-step="2"][data-group="lecture"] .mj-simulator__option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.multiply = parseFloat(btn.dataset.multiply);
      body.querySelectorAll('[data-step="2"][data-group="lecture"] .mj-simulator__option').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      updateLiveBar();
      buildResult();
      showStep('result');
    });
  });

  body.querySelectorAll('[data-step="2"][data-group="video"] .mj-simulator__option').forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.multiply = parseFloat(btn.dataset.multiply);
      body.querySelectorAll('[data-step="2"][data-group="video"] .mj-simulator__option').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      updateLiveBar();
      buildResult();
      showStep('result');
    });
  });

  body.querySelectorAll('[data-step="3"] input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener('change', function () { collectFeatures(); updateLiveBar(); });
  });

  body.querySelectorAll('.mj-simulator__next').forEach(function (btn) {
    btn.addEventListener('click', function () { collectFeatures(); buildResult(); showStep('result'); });
  });

  body.querySelectorAll('.mj-simulator__back').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var step = btn.closest('.mj-simulator__step').dataset.step;
      if (step === 'result') showStep(state.group === 'production' ? '3' : '2');
      else if (step === '3') showStep('2');
      else if (step === '2') showStep('1');
    });
  });

  var restartBtn = body.querySelector('.mj-simulator__restart');
  if (restartBtn) restartBtn.addEventListener('click', resetSim);

  /* Client name editing */
  var editClientBtn = document.getElementById('simEditClient');
  var clientNameEl = document.getElementById('simClientName');
  if (editClientBtn && clientNameEl) {
    editClientBtn.addEventListener('click', function () {
      clientNameEl.focus();
      var range = document.createRange();
      range.selectNodeContents(clientNameEl);
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    });
  }

  /* PDF print */
  var pdfBtn = document.getElementById('simSavePdf');
  if (pdfBtn) {
    pdfBtn.addEventListener('click', function () {
      var estimate = document.getElementById('simEstimate');
      if (!estimate) return;
      var printWin = window.open('', '_blank', 'width=800,height=1000');
      printWin.document.write('<!DOCTYPE html><html><head><meta charset="utf-8"><title>\u6982\u7B97\u898B\u7A4D\u66F8 - MJ-Lab</title>');
      printWin.document.write('<style>');
      printWin.document.write('*{margin:0;padding:0;box-sizing:border-box}');
      printWin.document.write('body{font-family:"Hiragino Kaku Gothic ProN","Yu Gothic","Meiryo",sans-serif;color:#1a1a1a;padding:48px 40px;max-width:800px;margin:0 auto;line-height:1.6}');
      printWin.document.write('.est-title{text-align:center;font-size:28px;font-weight:800;margin-bottom:32px;letter-spacing:0.1em}');
      printWin.document.write('.est-header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px}');
      printWin.document.write('.est-client{font-size:18px;font-weight:700}.est-client-suffix{font-size:14px;font-weight:400;margin-left:8px}');
      printWin.document.write('.est-issuer{text-align:right;font-size:13px;line-height:1.8}');
      printWin.document.write('.est-date{text-align:right;font-size:13px;color:#666;margin-bottom:16px}');
      printWin.document.write('.est-total{background:linear-gradient(135deg,#0d7377,#14919b);color:#fff;padding:16px 20px;border-radius:6px;display:flex;justify-content:space-between;align-items:center;font-size:16px;margin-bottom:24px}');
      printWin.document.write('.est-total-amount{font-size:28px;font-weight:800}');
      printWin.document.write('table{width:100%;border-collapse:collapse;margin-bottom:24px}');
      printWin.document.write('thead{background:linear-gradient(135deg,#0d7377,#14919b);color:#fff}');
      printWin.document.write('th{padding:10px 16px;text-align:left;font-size:13px;font-weight:600}th:last-child{text-align:right}');
      printWin.document.write('td{padding:12px 16px;border-bottom:1px solid #e5e5e5;font-size:14px}td:last-child{text-align:right;white-space:nowrap}');
      printWin.document.write('tr.sub td{font-weight:700;border-top:2px solid #ccc;border-bottom:1px solid #e5e5e5}');
      printWin.document.write('tr.total td{font-weight:800;font-size:16px;border-top:2px solid #1a1a1a;background:#f9f9f9}');
      printWin.document.write('.disclaimer{margin-top:32px;font-size:12px;color:#666;line-height:1.8;border-top:1px solid #e5e5e5;padding-top:16px}');
      printWin.document.write('.disclaimer strong{color:#1a1a1a;font-size:13px}');
      printWin.document.write('.footer{text-align:center;margin-top:40px;padding-top:16px;border-top:1px solid #e5e5e5;font-size:11px;color:#999}');
      printWin.document.write('@media print{body{padding:24px 20px}@page{margin:15mm 10mm}}');
      printWin.document.write('</style></head><body>');

      var clientName = clientNameEl ? clientNameEl.textContent : '\u682A\u5F0F\u4F1A\u793E\u3007\u3007';
      var dateText = document.getElementById('simEstimateDate') ? document.getElementById('simEstimateDate').textContent : '';
      var tax = Math.round(lastResultTotal * TAX_RATE);
      var taxIncluded = lastResultTotal + tax;

      printWin.document.write('<h1 class="est-title">\u6982\u7B97\u898B\u7A4D\u66F8</h1>');
      printWin.document.write('<p class="est-date">' + dateText + '</p>');
      printWin.document.write('<div class="est-header">');
      printWin.document.write('<div><span class="est-client">' + clientName + '</span><span class="est-client-suffix">\u5FA1\u4E2D</span></div>');
      printWin.document.write('<div class="est-issuer"><strong>MJ-Lab</strong><br>\u5411\u4E95 \u7D14\u4E00</div>');
      printWin.document.write('</div>');
      printWin.document.write('<div class="est-total"><span>\u5408\u8A08\u91D1\u984D</span><div style="text-align:right"><span class="est-total-amount">' + formatYen(taxIncluded) + '<small style="font-size:14px;font-weight:400">\uFF08\u7A0E\u8FBC\uFF09</small></span><br><small style="font-size:12px;opacity:.8">\u7A0E\u629C ' + formatYen(lastResultTotal) + '\uFF08\u6D88\u8CBB\u7A0E ' + formatYen(tax) + '\uFF09</small></div></div>');
      printWin.document.write('<table><thead><tr><th>\u9805\u76EE\u540D</th><th>\u91D1\u984D</th></tr></thead><tbody>');
      lastResultRows.forEach(function (r) {
        printWin.document.write('<tr><td>' + r.name + '</td><td>' + formatYen(r.price) + '</td></tr>');
      });
      printWin.document.write('<tr class="sub"><td>\u5C0F\u8A08</td><td>' + formatYen(lastResultTotal) + '</td></tr>');
      printWin.document.write('<tr class="sub"><td>\u6D88\u8CBB\u7A0E</td><td>' + formatYen(tax) + '</td></tr>');
      printWin.document.write('<tr class="total"><td>\u5408\u8A08\u91D1\u984D</td><td>' + formatYen(taxIncluded) + '</td></tr>');
      printWin.document.write('</tbody></table>');
      printWin.document.write('<div class="disclaimer"><p><strong>\u304A\u5BA2\u69D8\u3078\uFF08\u5FC5\u305A\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\uFF09</strong></p>');
      printWin.document.write('<p>\u672C\u8A18\u8F09\u306E\u91D1\u984D\u306F\u3042\u304F\u307E\u3067\u6982\u7B97\u3068\u306A\u308A\u307E\u3059\u3002</p>');
      printWin.document.write('<p>\u6B63\u5F0F\u306A\u304A\u898B\u7A4D\u308A\u306F\u3001\u304A\u6253\u3061\u5408\u308F\u305B\u306B\u3066\u8A73\u7D30\u3092\u304A\u4F3A\u3044\u3057\u305F\u5F8C\u306B\u3054\u63D0\u6848\u3055\u305B\u3066\u3044\u305F\u3060\u304D\u307E\u3059\u3002</p></div>');
      printWin.document.write('<div class="footer">MJ-Lab  \u6982\u7B97\u898B\u7A4D\u66F8</div>');
      printWin.document.write('</body></html>');
      printWin.document.close();
      setTimeout(function () { printWin.print(); }, 400);
    });
  }

  /* Copy result to clipboard */
  var copyBtn = document.getElementById('simCopyResult');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var tax = Math.round(lastResultTotal * TAX_RATE);
      var taxIncluded = lastResultTotal + tax;
      var text = '\u3010\u6982\u7B97\u898B\u7A4D\u308A\u7D50\u679C\u3011\n';
      text += '---\n';
      lastResultRows.forEach(function (r) {
        text += r.name + '\uFF1A' + formatYen(r.price) + '\n';
      });
      text += '---\n';
      text += '\u5C0F\u8A08\uFF1A' + formatYen(lastResultTotal) + '\n';
      text += '\u6D88\u8CBB\u7A0E\uFF1A' + formatYen(tax) + '\n';
      text += '\u5408\u8A08\u91D1\u984D\uFF1A' + formatYen(taxIncluded) + '\uFF08\u7A0E\u8FBC\uFF09\n';

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () {
          copyBtn.textContent = '\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\uFF01';
          setTimeout(function () { window.location.href = window.location.origin + '/contact/'; }, 800);
        });
      } else {
        var ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        copyBtn.textContent = '\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\uFF01';
        setTimeout(function () { window.location.href = window.location.origin + '/contact/'; }, 800);
      }
    });
  }

  /* Auto-open from URL parameter */
  var params = new URLSearchParams(window.location.search);
  var ps = params.get('service');
  if (ps) openSimModal(ps);
}
